import { render, staticRenderFns } from "./tableCorporation.vue?vue&type=template&id=87d29314"
import script from "./tableCorporation.vue?vue&type=script&lang=js"
export * from "./tableCorporation.vue?vue&type=script&lang=js"
import style0 from "./tableCorporation.vue?vue&type=style&index=0&id=87d29314&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports